import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  templateUrl: './helpModal.component.pug',
  styleUrls: ['./helpModal.component.scss'],
})
export class HelpModalComponent {
  @Input() content: string

  constructor (
    private modalInstance: NgbActiveModal,
  ) { }

  close () {
    this.modalInstance.dismiss()
  }
}
